
import Vue from "vue";

import {
  propertyChangeRequestMapState,
  propertyChangeRequestMapActions
} from "@/store/modules/propertychangerequest";
import EditPropertyChangeRequest from "@/views/shared/PropertyChangeRequest/SinglePropertyChangeRequests/EditPropertyChangeRequest.vue";

interface Idata {
  didInit: boolean;
  activeIndex: string;
  error: string;
  message: string;
  resourceNotFound: boolean;
  resourceNotFoundMsg: string;
}

export default Vue.extend({
  name: "SinglePropertyChangeRequest",
  components: {
    EditPropertyChangeRequest
  },
  data(): Idata {
    return {
      didInit: false,
      activeIndex: "info",
      error: "",
      message: "",
      resourceNotFound: false,
      resourceNotFoundMsg:
        "Ooops! The Policy change request you are looking for cannot be found."
    };
  },
  async created() {
    try {
      await this.getPropertyChangeRequest(this.propertyChangeRequestId);
    } catch (error) {
      this.resourceNotFoundMsg = error.message;
      this.resourceNotFound = true;
      this.$bugSnagClient.notify(error);
    } finally {
      this.didInit = true;
    }
  },
  methods: {
    ...propertyChangeRequestMapActions(["getPropertyChangeRequest"])
  },
  computed: {
    ...propertyChangeRequestMapState(["makingApiRequest", "editing"]),
    propertyChangeRequestId(): string {
      return this.$route.params.propertychangerequest_id;
    }
  }
});
